/**
 * Delivery regions for manual orders.
 *
 * Moved verbatim out of the old CreateOrder view so the wizard stays readable.
 * Still a hardcoded list (correcting a town needs a redeploy) - replacing it with
 * an API-backed lookup is tracked as deferred work.
 */
export const ORDER_REGIONS = {
    Kosove: [
      "Prishtinë",
      "Ferizaj",
      "Gjakovë",
      "Gjilan",
      "Mitrovicë",
      "Pejë",
      "Prizren",
      "Vushtrri",
      "Kastriot (Obiliq)",
      "Fushë Kosovë",
      "Suharekë (Therandë)",
      "Lipjan",
      "Malishevë",
      "Podujevë (Besianë)",
      "Deçan",
      "Dragash",
      "Istog (Burim)",
      "Klinë",
      "Leposaviq",
      "Shtime",
      "Rahovec",
      "Skënderaj",
      "Kaçanik",
      "Zveçan",
      "Novobërdë (Artanë)",
      "Zubin Potok",
      "Gllogoc (Drenas)",
      "Viti",
      "Kamenicë (Dardanë)",
      "Hani i Elezit",
      "Shtërpcë",
      "Kllokot",
      "Partesh",
      "Ranillug",
      "Graçanicë",
      "Mamushë",
      "Mitrovicë e Veriut",
      "Mitrovicë e Jugut",
      "Junik",
    ],
    Shqipëri: [
      "Berat",
      "Kuçovë",
      "Skrapar",
      "Bulqizë",
      "Dibër",
      "Mat",
      "Durrës",
      "Krujë",
      "Elbasan",
      "Gramsh",
      "Librazhd",
      "Peqin",
      "Fier",
      "Lushnje",
      "Mallakastër",
      "Gjirokastër",
      "Përmet",
      "Tepelenë",
      "Devoll",
      "Kolonjë",
      "Korçë",
      "Pogradec",
      "Has",
      "Kukës",
      "Tropojë",
      "Kurbin",
      "Lezhë",
      "Mirditë",
      "Malësi E Madhe",
      "Pukë",
      "Shkodër",
      "Kavajë",
      "Tiranë",
      "Delvinë",
      "Vlorë",
      "Kutalli",
      "Lumas",
      "Velabisht",
      "Otllak",
      "Poshnjë",
      "Roshnik",
      "Sinjë",
      "Terpan",
      "Ura Vajgurore",
      "Vertop",
      "Cukalat",
      "Kozare",
      "Perondi",
      "Bogovë",
      "Çepan",
      "Çorovodë",
      "Gjerbës",
      "Leshnjë",
      "Poliçan",
      "Potom",
      "Qendër",
      "Vendreshë",
      "Zhepë",
      "Fushë Bulqizë",
      "Gjoricë",
      "Trebisht",
      "Ostren",
      "Shupenzë",
      "Zerqan",
      "Martanesh",
      "Arras",
      "Fushë-Çidhën",
      "Kala E Dodës",
      "Kastriot",
      "Lurë",
      "Maqellarë",
      "Melan",
      "Fushë Muhur",
      "Peshkopi",
      "Qendër Tomin",
      "Selishtë",
      "Sllovë",
      "Zall Dardhë",
      "Zall Reç",
      "Luzni",
      "Baz",
      "Derjan",
      "Gurrë",
      "Klos",
      "Komsi",
      "Lis",
      "Macukull",
      "Burrel",
      "Rukaj",
      "Suç",
      "Ulëz",
      "Xibër",
      "Gjepalaj",
      "Ishëm",
      "Katund I Ri",
      "Maminas",
      "Manëz",
      "Rrashbull",
      "Shijak",
      "Sukth",
      "Xhafzotaj",
      "Bubq",
      "Cudhi",
      "Fushë Krujë",
      "Kodër Thumanë",
      "Nikël",
      "Belsh",
      "Bradashesh",
      "Cërrik",
      "Fierzë",
      "Funarë",
      "Gjergjan",
      "Gjinar",
      "Gostimë",
      "Gracen",
      "Grekan",
      "Kajan",
      "Labinot Fushë",
      "Labinot Mal",
      "Mollas",
      "Papër",
      "Rrasë",
      "Shalës",
      "Shirgjan",
      "Shushicë",
      "Tregan",
      "Zavalin",
      "Kodovjat",
      "Kushovë",
      "Lenie",
      "Pishaj",
      "Poroçan",
      "Skënderbegas",
      "Kukur",
      "Sult",
      "Tunjë",
      "Hotolisht",
      "Lunik",
      "Orenjë",
      "Përrenjas",
      "Polis",
      "Qukës",
      "Stëblevë",
      "Stravaj",
      "Rrajcë",
      "Gjocaj",
      "Karinë",
      "Pajovë",
      "Përparim",
      "Shezë",
      "Cakran",
      "Dermenas",
      "Frakull",
      "Ruzhdie",
      "Kuman",
      "Kurjan",
      "Levan",
      "Libofshë",
      "Mbrostar",
      "Patos",
      "Portëz",
      "Roskovec",
      "Strum",
      "Topojë",
      "Zharrës",
      "Allkaj",
      "Ballagat",
      "Bubullimë",
      "Divjakë",
      "Dushk",
      "Fiershegan",
      "Golem",
      "Grabian",
      "Gradishtë",
      "Hysgjokaj",
      "Karbunarë",
      "Krutje",
      "Rremas",
      "Tërbuf",
      "Aranitas",
      "Ballsh",
      "Fratar",
      "Greshicë",
      "Hekal",
      "Kutë",
      "Ngraçan",
      "Selitë",
      "Antigonë",
      "Cepo",
      "Dropull I Poshtëm",
      "Dropull I Sipërm",
      "Lazarat",
      "Libohovë",
      "Lunxhëri",
      "Odrie",
      "Picar",
      "Pogon",
      "Qendër Libohovë",
      "Zagori",
      "Ballaban",
      "Çarçovë",
      "Frashër",
      "Këlcyrë",
      "Sukë",
      "Dishnicë",
      "Petran",
      "Buz",
      "Fshat Memaliaj",
      "Krahës",
      "Kurvelesh",
      "Lopës",
      "Luftinjë",
      "Memaliaj",
      "Qesarat",
      "Bilisht",
      "Qendër Bilisht",
      "Miras",
      "Hoçisht",
      "Progër",
      "Barmash",
      "Çlirim",
      "Ersekë",
      "Leskovik",
      "Novoselë",
      "Drenovë",
      "Gorë",
      "Lekas",
      "Libonik",
      "Liqenas",
      "Maliq",
      "Moglicë",
      "Mollaj",
      "Pirg",
      "Pojan",
      "Vithkuq",
      "Voskop",
      "Voskopojë",
      "Vreshtas",
      "Buçimas",
      "Çërravë",
      "Dardhas",
      "Proptisht",
      "Trebinjë",
      "Hudenisht",
      "Velçan",
      "Fajza",
      "Golaj",
      "Gjinaj",
      "Krumë",
      "Arrën",
      "Bicaj",
      "Bushtricë",
      "Kolsh",
      "Malzi",
      "Zapod",
      "Shishtavec",
      "Shtiqën",
      "Surroj",
      "Tërthore",
      "Topojan",
      "Ujëmisht",
      "Grykë Çajë",
      "Kalis",
      "Bajram Curri",
      "Bujan",
      "Bytyç",
      "Lekbibaj",
      "Llugaj",
      "Margegaj",
      "Fushë Kuqe",
      "Laç",
      "Mamurras",
      "Milot",
      "Balldren I Ri",
      "Blinisht",
      "Dajç",
      "Kallmet",
      "Kolç",
      "Shëngjin",
      "Shënkoll",
      "Ungrej",
      "Zejmen",
      "Fan",
      "Kaçinar",
      "Kthjellë",
      "Orosh",
      "Rrëshen",
      "Rubik",
      "Gruemirë",
      "Kastrat",
      "Kelmend",
      "Koplik",
      "Shkrel",
      "Blerim",
      "Fushë Arrëz",
      "Gjegjan",
      "Iballë",
      "Qelëz",
      "Qerret",
      "Qafë Mali",
      "Rrapë",
      "Ana E Malit",
      "Bërdicë",
      "Bushat",
      "Guri I Zi",
      "Hajmel",
      "Vau I Dejës",
      "Postribë",
      "Pult",
      "Rrethinat",
      "Shalë",
      "Shllak",
      "Shosh",
      "Velipojë",
      "Vig-Mnelë",
      "Temal",
      "Gosë",
      "Helmës",
      "Kryevidh",
      "Lekaj",
      "Luz I Vogel",
      "Rrogozhinë",
      "Sinaballaj",
      "Synej",
      "Baldushk",
      "Bërxullë",
      "Bërzhitë",
      "Dajt",
      "Kamëz",
      "Kashar",
      "Ndroq",
      "Paskuqan",
      "Petrelë",
      "Pezë",
      "Prezë",
      "Farkë",
      "Shëngjergj",
      "Vaqarr",
      "Vorë",
      "Zall Bastar",
      "Zall Herr",
      "Kërrabë",
      "Finiq",
      "Mesopotam",
      "Vergo",
      "Dhivër",
      "Konispol",
      "Livadhja",
      "Lukovë",
      "Sarandë",
      "Xarrë",
      "Aliko",
      "Markat",
      "Ksamil",
      "Brataj",
      "Himarë",
      "Kote",
      "Orikum",
      "Selenicë",
      "Sevaster",
      "Vllahinë",
      "Vranisht",
      "Armen",
      "Fushë-Kuqë",
      "Fushë-Mamurras",
      "Fushë-Milot",
      "Vuno",
      "Sarande",
      "Kudhës",
      "Dhermi",
      "Jale",
      "Dhërmiu i Poshtëm",
      "Palasë",
      "Nivice",
      "Shenvasil",
      "Piqeras",
      "Porto Palermo",
      "Borsh",
      "Lukove",
      "Qeparo",
      "Llogara",
      "Malësi e Madhe",
      "Selite",
      "Babrru",
      "Rinas",
      "Pustec",
      "Diber",
    ],
    Maqedoni: [
      "Shkup",
      "Tetovë",
      "Gostivar",
      "Kumanovë",
      "Strugë",
      "Ohër",
      "Dibër",
      "Manastir",
      "Prilep",
      "Veles",
      "Koçan",
      "Gjevgjeli",
      "Shtip",
      "Kavadar",
      "Resnjë",
      "Kërçovë",
      "Radovish",
      "Berovë",
      "Negotinë",
      "Kriva Pallankë",
      "Bogdanci",
      "Dellçevë",
      "Sveti Nikole",
      "Demir Kapija",
      "Strumnica",
      "Valandova",
      "Likov",
    ],
};

export const ORDER_COUNTRIES = Object.keys(ORDER_REGIONS);
